<template>
  <div id="DummyChangeModal">
    <div class="modal-card" style="width:900px; height: 700px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">紐づけ先ユーザー検索</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>組織ID</th>
              <td><input type="text" class="validate" validate="required|numeric" v-model="searchConditions.belongsId" maxlength="9"/></td>
              <th>組織名</th>
              <td><input type="text" v-model="searchConditions.orgName"  maxlength="100"/></td>
              <th>営業所<span class="require" /></th>
              <td>
                <select v-model="salesOfficeCode" validate="required">
                  <option v-for="salesOffice in salesOfficeList" :value="salesOffice.code" :key="salesOffice.code">{{ salesOffice.name }}</option>
                </select>
              </td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="dummyExternalUserSearchContentTable"
            :data="data"
            :paginated="true"
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="belongsId" label="" width="20" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="belongsId" label="組織ID" width="20" sortable centered>{{props.row.belongsId}}</b-table-column>
              <b-table-column field="orgName" label="組織名" width="80" sortable>{{props.row.orgName}}</b-table-column>
              <b-table-column field="division" label="診療科名・部署名" width="70" sortable>{{props.row.division}}</b-table-column>
              <b-table-column field="kind" label="種別" width="40" sortable>{{props.row.kind | roleFilter}}</b-table-column>
              <b-table-column field="phoneNumber" label="連絡先" width="50" sortable>{{props.row.phoneNumber}}</b-table-column>
              <b-table-column field="branchOfficeCode" label="担当支店" width="50" sortable>{{props.row.branchOfficeName}}</b-table-column>
              <!-- <b-table-column field="salesStaffName" label="営業担当者" width="60" sortable>{{props.row.salesStaffName}}</b-table-column> -->
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot custom-footer">
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
        <button class="button ok-button" type="button" @click="select" :disabled="!selectedItem">選択</button>
      </footer>
    </div>
    <b-modal :active.sync="dummyChangeRegistModalActive">
      <dummyChangeRegistModal @select="linkExternalUser" :linkedInfo="linkedInfo" :dummyInfo="dummyInfo"></dummyChangeRegistModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  extUserStatus,
} from "@/components/mock/base/const.js";
import DummyChangeRegistModal from "@/components/mock/philips/common/DummyChangeRegistModal";
export default {
  name: "DummyChangeModal",
  props: {
    allowBlank:{type:Boolean, default: false, },
    dummyInfo: {default: "", },
  },
  methods: {
    doSearch: async function() {
      var _this = this;
      if (await this.inputCheck()) {
        _this.selectedItem = "";
        _this.searchConditions.salesOfficeCode = _this.salesOfficeCode;
        // 種別:医療機関, 状態:本登録
        _this.searchConditions.kindArry = [role.role_hospital];
        _this.searchConditions.status = extUserStatus.registed;
        _this.searchConditions.dummyUser = extUserStatus.dummy;
        // Web Api Call
        this.apiCall(
          function(client){
            var obj = JSON.parse(JSON.stringify(_this.searchConditions,));
            return client.apis.internalMaintenance.getMaintenanceExternalUserListPOST({
              body:obj
            });
          },
          async function(result){
            if (result.obj.length < 1) {
              _this.showMessage('該当するユーザーは存在しません。');
            }
            _this.data = result.obj;
          },
          function(result){
            _this.showErrorMessage(result);
          }
        );
      }
    },
    // 入力チェック
    inputCheck: function(){
      // 組織ID欄
      if (this.searchConditions.belongsId) {
        var elements = document.getElementsByClassName("validate")
        var result = this.selfMadeValidation(elements)
        if (result.isError) {
          this.showErrorMessage(result.msg)
          return false;
        }
      }
      // 営業所欄
      if (!this.salesOfficeCode) {
        this.showErrorMessage("営業所を設定してください。");
        return false;
      }
      return true;
    },
    select: async function() {
      // 押下した紐づけ先ユーザーの詳細情報を取得する
      await this.getExternalUserDetail(this.selectedItem);
      this.dummyChangeRegistModalActive = true;
    },
    getExternalUserDetail: async function(selectedItem){
      // Web Api Call
      var _this = this;
      // ユーザー指定で選択した組織情報を取得する
      var userId = selectedItem.userId;
      await this.apiCall(
        function(client){
          return client.apis.internalMaintenance.getMaintenanceExternalUserDetailPOST({
            body:{
              userId: userId,
            }
          });
        },
        function(result){
          _this.linkedInfo = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    linkExternalUser: async function() {
      // Web Api Call
      var _this = this;
      await this.apiCall(
        function(client){
          return client.apis.internalMaintenance.setMaintenanceDummyUserDeletePOST({
            body:{
              // useCpap: useCpap,
              // newUseServiceId: useService,
              linkedInfo: _this.linkedInfo,
              dummyInfo: _this.dummyInfo
            }
          });
        },
        async function(result){
          _this.showSuccess(result);
          // 紐づけ先ユーザーの情報で外部ユーザー登録画面を表示する
          // _this.back(_this.linkedUserId);
          if(_this.from =='control'){
            _this.$router.push({
              name: "ExternalUserControlSearch",
              params: {}
            });
          } else {
            _this.$router.push({
              name: "ExternalUserSearch",
              params: {}
            });
          }
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
  },
  data() {
    var from = decodeURIComponent(this.$route.query["from"]);
    var salesOfficeList = this.getSalesOfficeMaster();
    salesOfficeList.unshift({});
    return {
      data: [],
      from: from,
      salesOfficeList,
      salesOfficeCode: "",
      searchConditions:{
        belongsId: "",
        orgName: "",
        salesOfficeCode: "",
        kindArry: [],
        status: "",
        dummyUser: "",
      },
      dummyChangeRegistModalActive: false,
      dummyInfo: {},
      linkedInfo: {},
      linkedUserId: "",
      selectedItem: "",
    };
  },
  filters: {
    officeFilter(value,officeList){
      var target = officeList.find(val => val.code == value)
      if (target) {
        return target.name
      }
      return ""
    },
  },
  components: {
    dummyChangeRegistModal: DummyChangeRegistModal,
  },
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
.custom-footer {
  position: relative;
  display: flex;
  align-items: center;
}
.ok-button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/DummyChangeModal.vue